import React, { useEffect, useRef, useState } from "react";
import WaveSurfer from "wavesurfer.js";

const Waveform = ({ audio, containerRef, waveSurferRef }) => {
  const canvas = document.createElement("canvas");
  const ctx = canvas.getContext("2d");

  // Define the waveform gradient
  const gradient = ctx.createLinearGradient(0, 0, 0, canvas.height * 1.35);
  gradient.addColorStop(0, "#656666"); // Top color
  gradient.addColorStop((canvas.height * 0.7) / canvas.height, "#656666"); // Top color
  gradient.addColorStop((canvas.height * 0.7 + 1) / canvas.height, "#ffffff"); // White line
  gradient.addColorStop((canvas.height * 0.7 + 2) / canvas.height, "#ffffff"); // White line
  gradient.addColorStop((canvas.height * 0.7 + 3) / canvas.height, "#B1B1B1"); // Bottom color
  gradient.addColorStop(1, "#B1B1B1"); // Bottom color

  // Define the progress gradient
  const progressGradient = ctx.createLinearGradient(
    0,
    0,
    0,
    canvas.height * 0.35
  );
  progressGradient.addColorStop(0, "#EE772F"); // Top color
  progressGradient.addColorStop(
    (canvas.height * 0.7) / canvas.height,
    "#7C4DFF"
  ); // Top color
  progressGradient.addColorStop(
    (canvas.height * 0.7 + 1) / canvas.height,
    "#ffffff"
  ); // White line
  progressGradient.addColorStop(
    (canvas.height * 0.7 + 2) / canvas.height,
    "#ffffff"
  ); // White line
  progressGradient.addColorStop(
    (canvas.height * 0.7 + 3) / canvas.height,
    "#F6B094"
  ); // Bottom color
  progressGradient.addColorStop(1, "#F6B094"); // Bottom color

  useEffect(() => {
    const waveSurfer = WaveSurfer.create({
      container: containerRef.current,
      waveColor: gradient,
      progressColor: progressGradient,
      barWidth: 4,
      barGap: 5,
      barRadius: 8,
      height: 20,
      responsive: true,
    });
    waveSurfer.load(audio);

    waveSurfer.on("ready", () => {
      waveSurferRef.current = waveSurfer;
      waveSurferRef.current.playPause();
    });

    return () => {
      waveSurfer.destroy();
    };
  }, [audio]);

  return <div ref={containerRef} style={{ width: "100%" }} />;
};

export default Waveform;
